import { SIGN_UP, SignUp, SignUpRequestDto } from '../types/sign-up'

export const signUp = (payload: SignUpRequestDto): SignUp => {
  return {
    type: SIGN_UP,
    payload,
  }
}
